// src/AuthContext.jsx
import { createContext, useEffect, useState, useContext } from "react";
import { auth } from "../Firebase";
import { onAuthStateChanged } from "firebase/auth";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setReady(true);
    });
    return () => unsub();
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready }}>
      {children}
    </AuthCtx.Provider>
  );
}

// Safe hook: never returns null
export const useAuth = () => useContext(AuthCtx) ?? { user: null, ready: false };
